import { useEffect, useLayoutEffect } from "react";
import canUseDOM from "../canUseDOM";
const useLayoutEffectImpl = canUseDOM ? useLayoutEffect : useEffect;
var useLayoutEffect_default = useLayoutEffectImpl;
export {
  useLayoutEffect_default as default
};
//# sourceMappingURL=index.js.map
